@for (idvApplicationSummaryItem of idvApplicationSummaryItems; track idvApplicationSummaryItem) {
  <div class="processing-summary-section">
    <div class="header-items" (click)="toggleCollapsableItem(idvApplicationSummaryItem)">
      <div class="content">
        <rkt-icon
          class="menu-icon profile"
          [name]="getProfileIcon($safeNavigationMigration(idvApplicationSummaryItem?.accountTypeInfo))"
        ></rkt-icon>
        <span class="display-text">{{ idvApplicationSummaryItem?.displayName }}</span>
      </div>
      <div class="content">
        <span class="status-tag" [ngClass]="'status-tag-' + $safeNavigationMigration(idvApplicationSummaryItem?.entityVerificationStatus)">
          {{ idvApplicationSummaryItem?.latestStatus }}
        </span>
        <rkt-icon
          class="menu-icon toggle"
          [name]="idvApplicationSummaryItem.collapseSectionExpanded ? 'chevron-up' : 'chevron-down'"
        ></rkt-icon>
      </div>
    </div>
    @if (idvApplicationSummaryItem.collapseSectionExpanded) {
      <div class="summary-description">
        @if (idvApplicationSummaryItem?.entityVerificationOutcome) {
          <div class="idv-outcome-row">
            <div class="identity-application-details-outcome">
              <div
                class="identity-outcome-tag-item status-tag"
                [ngClass]="'status-tag-' + $safeNavigationMigration(idvApplicationSummaryItem?.entityVerificationOutcome?.toLowerCase())"
              >
                {{ $safeNavigationMigration(idvApplicationSummaryItem?.entityVerificationOutcome) | titlecase }}
              </div>
            </div>
            <div class="idv-outcome-row-tags">
              @for (outcomeDetailsTag of idvApplicationSummaryItem?.outcomeDetailsTags; track outcomeDetailsTag) {
                <div class="identity-application-details-outcome">
                  <div class="identity-outcome-tag-item">
                    <div class="status-icon" [ngClass]="'status-icon-' + getTagColor(outcomeDetailsTag)"></div>
                    {{ outcomeDetailsTag }}
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="separator-line"></div>
        }
        <div class="details-row">
          <app-details-item
            [class]="pageClassPrefix + 'processing-summary-display-name'"
            [showPlaceholder]="loading"
            [label]="isBusinessCustomer(idvApplicationSummaryItem) ? 'Business Legal Name' : 'Name'"
            [value]="$safeNavigationMigration(idvApplicationSummaryItem?.displayName)"
          ></app-details-item>
          @if (!isBusinessCustomer(idvApplicationSummaryItem)) {
            <app-details-item
              [class]="pageClassPrefix + 'processing-summary-date-of-birth'"
              [showPlaceholder]="loading"
              label="DOB"
              [value]="$safeNavigationMigration(idvApplicationSummaryItem?.dateOfBirth) | dateFormat: 'MM/dd/yy' : 'ISO'"
            ></app-details-item>
          }
          @if (!isBusinessCustomer(idvApplicationSummaryItem)) {
            <app-details-item
              [class]="pageClassPrefix + 'processing-summary-email'"
              [showPlaceholder]="loading"
              label="Email"
              [value]="$safeNavigationMigration(idvApplicationSummaryItem?.emailAddress)"
            ></app-details-item>
          }
          <app-details-item
            [class]="pageClassPrefix + 'processing-summary-phone'"
            [showPlaceholder]="loading"
            label="Phone"
            [value]="$safeNavigationMigration(idvApplicationSummaryItem?.phoneNumber)"
          ></app-details-item>
          <app-details-item
            [class]="pageClassPrefix + 'processing-summary-address'"
            [showPlaceholder]="loading"
            label="Address"
            [value]="$safeNavigationMigration(idvApplicationSummaryItem?.address?.addressLine1)"
          >
            @if (idvApplicationSummaryItem?.address?.addressLine1) {
              <div>{{ idvApplicationSummaryItem?.address?.addressLine2 }}</div>
              <div>{{ idvApplicationSummaryItem?.address?.city }}, {{ idvApplicationSummaryItem?.address?.state }}</div>
              <div>{{ idvApplicationSummaryItem?.address?.postalCode }} {{ idvApplicationSummaryItem?.address?.country }}</div>
            }
          </app-details-item>
          @if (!isBusinessCustomer(idvApplicationSummaryItem)) {
            <app-details-item
              [class]="pageClassPrefix + 'processing-summary-documents'"
              [showPlaceholder]="loading"
              label="Documents"
              [contentValue]="true"
            >
              @if (applicationHasHostedDocumentLink(idvApplicationSummaryItem)) {
                <div class="document-item idv-upload" (click)="uploadDocumentModal(idvApplicationSummaryItem)">
                  <rkt-icon class="menu-icon link-icon" [name]="'link'"></rkt-icon>
                  <span class="document-link">Upload document link</span>
                </div>
              } @else {
                @if (idvApplicationSummaryItem?.documentList?.length) {
                  @for (document of idvApplicationSummaryItem?.documentList; track document) {
                    <div class="document-item" [title]="document">
                      <rkt-icon class="menu-icon" [name]="getProfileIcon(document)"></rkt-icon>
                      <span class="display-text">{{ document | titlecase }}</span>
                    </div>
                  }
                } @else {
                  <span class="display-text">N/A</span>
                }
              }
            </app-details-item>
          }
        </div>
      </div>
    }
  </div>
}
